import React from "react";
import '../index.css';
import CanonicalTag from "./CanonicalTag";
import { Helmet } from "react-helmet";
import cementklin from '../assets/Images/cement kiln.jpg'
import verticalshaft from '../assets/Images/shaft-kiln.jpg'
import kilnDiagram from '../assets/Images/rotary-kiln-diagram.jpg';
import vibrating from '../assets/Images/vibrating-screen-machine.jpg';
import vibrating1 from '../assets/Images/rectangular-vibrating-screen.jpg'
import vibratingscreen from '../assets/Images/vibrating-screen.jpg'
const CementProduction = () => {
  return (
    <>
    
    <Helmet>
        <title>Cement Porduction| Valerion Impex</title>
        <meta
          name="description"
          content="Explore high-quality cement products including OPC and PPC cement at Valerion Impex. Suitable for hydraulic structures, plastering, and more."
        />
      </Helmet>
      
        <CanonicalTag url="https://www.cementmachineryparts.in/products/cement-production" />
    <div>
      <div className="container mt-3">
        <h1 className="text-center bg-dark mb-3 mx-auto text-white cement-raw rounded"> Clinker Production Equipments</h1>
        <p className="text-center text-primary fw-bold fs-2">Cement kiln</p>
        <div className="row mb-3 align-items-start">

          <div className="col-lg-6 text-center">
            <img src={cementklin} alt="Rotary Kiln" className="img-fluid mb-3" />

            <div className="text-start ps-4">
              <ul>
                <li><span className="text-danger fw-bold">Power:</span> 17-630 kw</li>
                <li><span className="text-danger fw-bold">Capacity:</span> 10-5000 t/d</li>
                <li><span className="text-danger fw-bold">Application:</span> cement production line, lime production line, etc</li>
              </ul>
            </div>

            <div className="position-relative d-inline-block mt-4">
              <div style={{ fontSize: "24px", position: "absolute", top: "-30px", left: "50%", transform: "translateX(-50%)" }}>↑</div>
              <button className="btn kiln-btn">Rotary Kiln</button>
            </div>
          </div>

          <div className="col-lg-6 text-center">
            <p className="text-justify">
              <strong>Cement rotary kilns</strong> refer to cement rotary calcining kilns (sometimes called rotary furnaces). It is a pyroprocessing device used to heat materials to high temperatures in a continuous process. The kiln body is a cylinder vessel with a certain degree of tilt to the horizontal level. Raw materials are fed into the vessel from the upper end and moved to the lower end, being stirred and mixed relying on the inclination and rotation of the kiln. The kiln burner produces a lot of heat by burning fuel. This kind of heat is usually transferred to materials through flame radiation, hot gas convection, kiln brick conduction, etc., which causes the chemical reaction between raw materials and finally forms clinker.
            </p>
            <div className="fs-2"></div>
            <img src={kilnDiagram} alt="Rotary Kiln Diagram" className="img-fluid mt-1" />
          </div>
        </div>


        <div className="row align-items-start">

          <div className="col-lg-6 text-center">

            <img src={verticalshaft} alt="Shaft Kiln Diagram" className="img-fluid verticalshaft mb-2" />
          </div>


          <div className="co
          l-lg-6 text-start py-3">
            <ul>
              <li><span className="text-danger fw-bold">Power:</span> 22-55 kw</li>
              <li><span className="text-danger fw-bold">Capacity:</span> 12-35 t/h</li>
              <li><span className="text-danger fw-bold">Application:</span> vertical shaft kiln, cement plant, lime production line</li>
            </ul>
            <p>Shaft kiln, also called vertical shaft kiln or vertical kiln, is a kind of vertical set stationary cement kiln, usually applied in the cement production line, lime production line, etc. As one of the main cement equipment, it plays the same role as a cement rotary kiln for cement clinker manufacturing, also composed of preheating zone, calcining zone, and cooling zone, while no matter the production process, investment or cement properties, it is different from the rotary kiln.</p>
            <button className="btn kiln-btn mt-2">Shaft Kiln</button>
          </div>
        </div>


        {/* -------------------Vibrating Screens-------------- */}

        <div className="row">

          <div className="cement-raw bg-dark text-white text-center mt-2 mb-3  rounded">
            <h3>Recognized around the world for quality and endurance at competitive prices</h3>
            <h3>CONTACT US AND WE WILL GET BACK TO YOU IN UNDER 24 HOURS</h3>
          </div>

        </div>

        <div className="row">
          <div className="col-12">
            <p className="text-center text-primary fs-1 fw-bold">Vibrating Screens</p>
          </div>
        </div>


        <div className="row align-items-start mb-4">
          <div className="col-lg-4 col-md-12 mb-3">
            <img src={vibrating} alt="Vibrating Screen" className="img-fluid rounded" />
          </div>
          <div className="col-lg-4 col-md-12 fs-5 mb-3">
            <p>
              Vibrating screen machine is also called vibrating screen. It is a kind of material screening equipment, as well as important cement equipment, applied in cement production lines, stone crushing plants, cement grinding units, etc.
            </p>
          </div>
          <div className="col-lg-4 col-md-12 mb-2">
            <img src={vibrating1} alt="Vibrating Screen" className="img-fluid rounded" />
          </div>
        </div>


        <div className="row align-items-start mb-3">
          <div className="col-lg-6 col-md-12 py-3 mb-2">
            <ul>
              <li>Our screening machine features high efficiency, small space occupation, lightweight, large capacity, long service cycle, and long service life.</li>
              <li>Our equipment adopts the universal joint pin, rubber coupling, and other flexible connections to ensure steady running.</li>
              <li>The equipment maintenance is simple and convenient, and the operation benefit of the whole machine is obvious.</li>
              <li>The sealing place is closed by a soft connection, which reduces the pollution to the atmospheric environment.</li>
              <li>Low cost, more practical in the production process.</li>
            </ul>
          </div>
          <div className="col-lg-6 col-md-12">
            <img src={vibratingscreen} alt="Vibrating Screen Full" className="img-fluid rounded vibratingscreen" />
          </div>
        </div>
      </div>

    </div>
    </>

  );
};


export default CementProduction;